import React, { useContext } from "react";

import BackButton from "../../components/Buttons/BackButton";
import Container from "../../components/Container";
import CustomHead from "../../components/CustomHead";
import Layout from "../../components/Layout";
import TopicHeader from "../../components/TopicHeader";
import fetchRequestLibrary from "../../utils/fetchRequestLibrary";
import { Context } from "../../utils/store";

export default function AnnonceLegale({
  pagename,
  thematiques,
  breakingNews,
  cities,
  ephemeralChannels,
  liveData,
  medias,
  data,
}) {
  const context = useContext(Context);

  return (
    <Context.Provider
      value={{
        ...context,
        activePage: "annoncesLegales",
        thematiques,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        medias,
      }}
    >
      <Layout>
        <Container>
          <CustomHead title="Annonces légales" />
          <TopicHeader topic={"Annonces légales"} type={"annoncesLegales"} />
          <BackButton />
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              marginTop: "20px",
            }}
            dangerouslySetInnerHTML={{ __html: data }}
          />
        </Container>
      </Layout>
    </Context.Provider>
  );
}

export async function getServerSideProps(context) {
  const {
    thematiques,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
  } = await fetchRequestLibrary();

  const { id } = context.query;

  let data = await fetch(
    `https://manager.canal32.fr/rest/3.0/notices.php?uuid=${id}`,
    {
      method: "GET",
    }
  );
  data = await data.text();

  let pagename = data?.items?.[0]?.pagetitle || "Aucune data";

  return {
    props: {
      pagename,
      thematiques,
      breakingNews,
      cities,
      ephemeralChannels,
      liveData,
      medias,
      data,
    },
  };
}
